import { useEffect, useRef, useState } from "react";
import "./Contact_us.css";
import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Success_Modal from "../common-components/common_Modal/success_modal/Success_Modal";
import emailjs from "emailjs-com";

const Contact_us = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [modalShow, setModalShow] = useState(false);

  const [phoneValue, setPhoneValue] = useState("");

  function handleClick(el) {
    el.classList.toggle("float-label-top");
  }

  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_lv4d7yc",
        "template_6zs8zi7",
        form.current,
        "Dw0r1_JW08kA0IfJ4", // from EmailJS dashboard
      )
      .then(
        (result) => {
          console.log("Email Sent", result.text);
          setModalShow(true);
        },
        (error) => {
          console.error("Email Error", error.text);
        },
      );
  };

  const [isFlipped, setIsFlipped] = useState(false);

  const handleImageClick = () => {
    setIsFlipped(!isFlipped);
  };
  return (
    <>
      <section className="Contact_us_section">
        <div className="container">
          <div
            className={`flip-card ${
              isFlipped ? "flipped" : "" || isFlipped ? "" : ""
            } `}
          >
            <div className="main_sec">
              <div className="form_sec">
                <div className="row">
                  <div className="col-lg-6 order-lg-1 order-2">
                    <div className="contform">
                      <p className="cont_title">Contact us</p>
                      <h3 className="feelh6">Feel Free to Contact Us</h3>

                      <Form className="mt-4" ref={form} onSubmit={handleSubmit}>
                        <div className="form-group">
                          <Form.Control
                            type="text"
                            required
                            name="fullName"
                            placeholder="Enter Full Name*"
                          />
                        </div>
                        <div className="form-group">
                          <Form.Control
                            type="email"
                            required
                            name="email"
                            placeholder="Enter Email"
                          />
                        </div>
                        <div className="form-group">
                          <PhoneInput
                            country={"in"}
                            required
                            enableSearch={true}
                            inputProps={{
                              name: "phone",
                              required: true,
                              autoFocus: true,
                              placeholder: "Enter Contact Number*",
                            }}
                          />
                        </div>

                        <div className="form-group">
                          <Form.Control
                            type="text"
                            name="city"
                            required
                            placeholder="Enter City"
                          />
                          {/* <Form.Select aria-label="Default select example">
                                                        <option>Enter City</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </Form.Select> */}
                        </div>

                        <div className="form-group">
                          <FloatingLabel controlId="floatingTextarea2" label="">
                            <Form.Control
                              as="textarea"
                              required
                              name="message"
                              placeholder="Write your message here"
                              style={{ height: "100px" }}
                            />
                          </FloatingLabel>
                        </div>

                        <div className="form-group text-center">
                          <button className="submit-button" type="submit">
                            Submit
                          </button>
                        </div>
                      </Form>
                    </div>
                  </div>
                  <div className="col-lg-6 order-lg-2 order-1">
                    <div className="contdetails">
                      <img
                        className="contimg"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/contact-us/contbaner.png"
                        }
                      />

                      <div className="phonemsec">
                        <div className="row">
                          <div className="col-lg-6 mb-3">
                            <div className="det_box">
                              <div className="icondiv">
                                <img
                                  className="icon"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/contact-us/call.png"
                                  }
                                />
                              </div>
                              <div className="detaildiv">
                                <p className="det_title">Phone</p>
                                <p className="det_text">+91 9836886605</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 mb-3">
                            <div className="det_box">
                              <div className="icondiv">
                                <img
                                  className="icon"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/contact-us/email.png"
                                  }
                                />
                              </div>
                              <div className="detaildiv">
                                <p className="det_title">Email</p>
                                <p className="det_text">
                                  apusikder60@gmail.com
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="det_box">
                              <div className="icondiv">
                                <img
                                  className="icon"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/contact-us/location.png"
                                  }
                                />
                              </div>
                              <div className="detaildiv adreeposition">
                                <p className="det_title">Address</p>
                                <p className="det_text">
                                  Sahidpally, Kalyani, Nadia - 741251, West
                                  Bengal
                                </p>

                                <p
                                  className="findmap"
                                  onClick={handleImageClick}
                                >
                                  Find Us on Map
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flip-card-back">
                <div className="map-section">
                  <div className="mapouter">
                    <div className="gmap_canvas">
                      <iframe
                        className="gmap_iframe"
                        frameborder="0"
                        scrolling="no"
                        marginheight="0"
                        marginwidth="0"
                        src="https://maps.google.com/maps?width=600&amp;height=800&amp;hl=en&amp;q=pune&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                      ></iframe>
                      <a href="https://pdflist.com/" alt="pdflist.com"></a>
                    </div>
                  </div>

                  <img
                    onClick={handleImageClick}
                    className="close-map-icon"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/contact-us/close.png"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Success_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Submited Sucessfully"
      />
    </>
  );
};

export default Contact_us;
